import { makeStyles, Theme } from "@material-ui/core";
import { tesaDarkRedError } from "../../../../styles/colors";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    "& h2, p": {
      margin: 0,
    },
  },
  dropdownItems: {
    "& div.MuiFormControl-root": {
      margin: `${theme.spacing(3)}px 0 ${theme.spacing(3)}px 0`,
    },
  },
  labeledCheckbox: {
    display: "flex",
  },
  checkbox: {
    paddingLeft: 0,
  },
  error: {
    color: tesaDarkRedError,
  },
}));

export default useStyles;
